import { ContentPlanner } from "./pages/ContentPlanner";
import { ContentPack } from "./pages/ContentPack";
import { createRoot, hydrateRoot } from "react-dom/client";
import { Router, Route } from "./lib/router";
import { ThemeProvider } from "./lib/theme";
import { StaticDataProvider, getInitialStaticData } from "./lib/static-data";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { Layout } from "./components/Layout";
import { Home } from "./pages/Home";
import { Features } from "./pages/Features";
import { Pricing } from "./pages/Pricing";
import { Blog } from "./pages/Blog";
import { BlogArticle } from "./pages/BlogArticle";
import { AyrshareComparison } from "./pages/AyrshareComparison";
import { Privacy } from "./pages/Privacy";
import { Terms } from "./pages/Terms";
import { DataDeletion } from "./pages/DataDeletion";

const staticData = getInitialStaticData();

function App() {
  return (
    <ErrorBoundary>
      <StaticDataProvider data={staticData}>
        <ThemeProvider>
          <Router>
            <Layout>
              <Route path="/" component={Home} />
              <Route path="/content-pack" component={ContentPack} />
              <Route path="/resources/7-day-content-planner" component={ContentPlanner} />
              <Route path="/features" component={Features} />
              <Route path="/pricing" component={Pricing} />
              <Route path="/blog" component={Blog} />
              <Route path="/blog/linkedin-posting-api" component={BlogArticle} />
              <Route path="/blog/instagram-publishing-api" component={BlogArticle} />
              <Route path="/blog/social-media-posting-api" component={BlogArticle} />
              <Route path="/blog/postiz-alternatives" component={BlogArticle} />
              <Route path="/blog/ayrshare-alternatives" component={BlogArticle} />
              <Route path="/compare/ayrshare" component={AyrshareComparison} />
              <Route path="/privacy" component={Privacy} />
              <Route path="/terms" component={Terms} />
              <Route path="/data-deletion" component={DataDeletion} />
            </Layout>
          </Router>
        </ThemeProvider>
      </StaticDataProvider>
    </ErrorBoundary>
  );
}

const root = document.getElementById("root")!;

if (root.childNodes.length > 0 && (window as any).__STATIC_DATA__) {
  hydrateRoot(root, <App />);
} else {
  createRoot(root).render(<App />);
}
